module.exports = __webpack_public_path__ + "static/img/21.ec8df612.gif";